const CAMPAIGN_STORAGE_KEY = 'signup-campaign';

// Signup campaign attribution: a dedicated lander records its campaign key at load, and the key
// rides the verify-email request so the player receives that campaign's branded email. Cleared
// post-login alongside the lander gift key, once the signup it belongs to is finished.
export class CampaignService {
  static setCampaign(key: string) {
    try {
      localStorage.setItem(CAMPAIGN_STORAGE_KEY, key);
    } catch {
      // Blocked storage (private mode) — the player simply receives the default branded email.
    }
  }

  static getCampaign(): string | undefined {
    try {
      return localStorage.getItem(CAMPAIGN_STORAGE_KEY) ?? undefined;
    } catch {
      return undefined;
    }
  }

  static clear() {
    try {
      localStorage.removeItem(CAMPAIGN_STORAGE_KEY);
    } catch {
      // Nothing to clean when storage is blocked.
    }
  }
}
